import { useMutation, gql } from 'urql';

export interface ExternalParticipant {
  firstName: string;
  lastName: string;
  email?: string;
  phone?: string;
}

interface ICreateTicketsVariables {
  input?: {
    checked?: boolean;
    active?: boolean;
  };
  participantIds?: number[];
  guestsData?: ExternalParticipant[];
  eventId: number;
  segmentId?: number;
  source?: string;
}

interface CreateTicketResponse {
  id: string;
  ticketUuid: string;
  checked: boolean;
  active: boolean;
  createdAt: string;
  updatedAt: string;
  ticketSegmentId: string;
}

interface ICreateTicketsResponse {
  createTicket: {
    tickets: CreateTicketResponse[];
    errorsData: ExternalParticipantError[];
  };
}
interface ExternalParticipantError {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  errorText: string;
}

const CREATE_TICKETS_MUTATION = gql`
  mutation createTickets(
    $input: CreateTicketInput!
    $guestsData: [ExternalParticipant!]
    $participantIds: [Int!]!
    $eventId: Int!
    $segmentId: Int
    $source: String
  ) {
    createTicket(
      input: $input
      participantIds: $participantIds
      guestsData: $guestsData
      eventId: $eventId
      segmentId: $segmentId
      source: $source
    ) {
      tickets {
        id
        ticketUuid
        checked
        active
        createdAt
        updatedAt
        ticketSegmentId
      }
      errorsData {
        firstName
        lastName
        email
        phone
        errorText
      }
    }
  }
`;

export const useCreateTickets = () => {
  const [result, executeMutation] = useMutation<ICreateTicketsResponse, ICreateTicketsVariables>(
    CREATE_TICKETS_MUTATION
  );

  const createTickets = (params: ICreateTicketsVariables) => {
    return executeMutation({
      input: {
        checked: false,
        active: true,
      },
      participantIds: params.participantIds ?? [],
      guestsData: params.guestsData ?? [],
      eventId: params.eventId,
      segmentId: params.segmentId,
      source: params.source || undefined,
    });
  };
  return { createTickets, fetching: result.fetching };
};
